import { useNavigate, useSearchParams } from "react-router-dom";

export const useNavigateWithSearchParams = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const handleNavigate = (
		path: string,
		newParams?: Record<string, string>,
	) => {
		const queryParams = new URLSearchParams(searchParams);
		if (newParams) {
			Object.entries(newParams).forEach(([key, value]) => {
				queryParams.set(key, value);
			});
		}

		const newUrl = `${path}?${queryParams.toString()}`;
		navigate(newUrl);
	};

	return [handleNavigate];
};
